(function (global, factory) {
    if (typeof exports === 'object') {
        module.exports = factory( require('./api.js'), require('../../fht/fh_common.js') );
    } else if ( typeof define === 'function' && define.amd ) {
        define(['api', 'common'], factory);
    }
}(this, function (apiModule, commonModule) {
    var API = apiModule.api,
        Service = apiModule.Service,
        QuestionnaireService = new Service({
            name: 'questionnaire',
            url: '/api2/question/',
            allowedMethods: ['get','post', 'put', 'delete'],
            interfaces: ['createTree','create', 'mailOnComplete', 'mailOnStart', 'getConcepts'],
            methodProviders: {},
            ajaxSettings: {
                beforeSend: function(xhr, settings) {
                    if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && !this.crossDomain) {
                        var csrftoken = commonModule.getCookie('csrftoken');
                        xhr.setRequestHeader("X-CSRFToken", csrftoken);
                    }
                }
            }
        });

    QuestionnaireService.create         = function (data)  { return this.post({data:data}) };
    QuestionnaireService.createTree     = function (token) { return this.post({data:{token:token}}) };
    QuestionnaireService.mailOnComplete = function (token, locale) {
        return this.post({data:{language:locale}}, token, 'mail-on-complete');
    };
    QuestionnaireService.mailOnStart = function (token, locale) {
        return this.post({data:{language:locale}}, token, 'mail-on-start');
    };
    QuestionnaireService.getConcepts    = function () { return this.get({url: '/api2/questionnaire-conditions'}) };

    API.registerService(QuestionnaireService);

return QuestionnaireService;

}));
